var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":"grey lighten-3"},on:{"click":function($event){$event.stopPropagation();return _vm.goTo.apply(null, arguments)}}},[_vm._t("default"),_c('v-icon',{staticClass:"ml-1"},[_vm._v("mdi-arrow-right")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }